import CustomForm from "../CustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import {ImageItem} from "../../model/items/imageItem";
import {CheckboxItem} from "../../model/items/checkbox";
import CheckboxCell from "../shared/components/FormCell/CheckboxCell";

export default abstract class ImageHighlighterCF extends CustomForm
{
    protected checkboxes: CheckboxCell[] = [];

    protected imageWithHighlighter!: ImageItem;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof ImageItem && cellItem.hasHighlighter()) {
                    this.imageWithHighlighter = cellItem;
                } else if (cellItem instanceof CheckboxItem) {
                    this.checkboxes.push( new CheckboxCell(
                        cell,
                        (ci, v) => {
                            this.onSetValue(ci, v);
                            this.imageWithHighlighter.reset();
                        },
                    ));
                }
            }
        }
    }


    checkRequirements(): boolean {
        if (!this.imageWithHighlighter) {
            console.log("ImageHighlighter: Image with highlighter not found.");
            return false;
        }

        return true
    }
}